import React, { useState } from "react";

import { InfoRegular } from "@fluentui/react-icons";
import { Text, mergeClasses } from "@fluentui/react-components";

import { Stack } from "@/components/stack";
import { PlaybookViewer } from "@/components/playbook-viewer";
import { YellowpadPlaybookCard } from "@/components/yellowpad-playbook-card";
import { useYellowpadPlaybooksStyles } from "./styles";

import { Playbook } from "@/types/risk-analysis";

interface YellowpadPlaybooksProps extends React.ComponentPropsWithoutRef<"div"> {
  playbooks: Playbook[];
}

export function YellowpadPlaybooks({ playbooks, className, ...props }: YellowpadPlaybooksProps) {
  const styles = useYellowpadPlaybooksStyles();

  const [page, setPage] = useState<"view-playbook" | "main">("main");
  const [selectedPlaybook, setSelectedPlaybook] = useState<Playbook>();

  const handleOpenPlaybook = (playbook: Playbook) => {
    setSelectedPlaybook(playbook);
    setPage("view-playbook");
  };

  const handleGoBack = () => {
    setSelectedPlaybook(undefined);
    setPage("main");
  };

  if (page === "view-playbook" && selectedPlaybook) {
    return <PlaybookViewer playbook={selectedPlaybook} onGoBack={handleGoBack} />;
  }
  return (
    <div
      role="tabpanel"
      aria-labelledby="Yellowpad Playbooks"
      className={mergeClasses(styles.container, className)}
      {...props}
    >
      {playbooks.length === 0 && (
        <Stack direction="column" align="center" justify="center" style={{ marginTop: "1rem" }}>
          <InfoRegular style={{ fontSize: "1.5rem" }} />
          <Text>No playbooks found!</Text>
        </Stack>
      )}
      {playbooks.length > 0 && (
        <Stack direction="column" gap="1rem">
          {playbooks.map((playbook) => (
            <YellowpadPlaybookCard key={playbook.id} playbook={playbook} onOpen={() => handleOpenPlaybook(playbook)} />
          ))}
        </Stack>
      )}
    </div>
  );
}
